<dashboard-dialog-frame icon='fa-regular fa-hand-pointer' header='Set Class Speaker' [actions]='actions' [dialogRef]='dialogRef'>

	<div class="entrepreneurs-set-class-speaker-dialog p-2">
		<table style='width:100%' class='pro-table pro-table-no-header pro-table-with-labels pro-table-without-border'>
			<tr>
				<td style="width: 20%;">Class Speaker</td>
				<td>
					<droplist [items]='droplistItems()' [selectedItem]='initialSelection()' (selectionChange)='onViewDroplistChange($event)'>
					</droplist>
				</td>
			</tr>
		</table>
	</div>

</dashboard-dialog-frame>